<template>
  <div class="talentsStore">
    <OATable :data="data" :columns="columns" :filterData="filterData" :selectionRow="true" @search="handleSearch"
      @selectionChange="selectionChange" :loading="loading">
      <div slot="button">
        <OAButton @click="handleAdd('1')" :disabled="!checkList.length">评价</OAButton>
        <OAButton @click="handleAdd('2')" :disabled="!checkList.length">入职</OAButton>
        <OAButton class="pull-right" @click="handleAdd">新增</OAButton>
      </div>
    </OATable>
  </div>
</template>
<script>
  import talentsApi from "@/services/talents.js";
  import OAJump from "@/components/OAJump/OAJump";
  import {
    jump
  } from "@/common/jump";

  export default {
    name: "talentsStore",
    components: {
      OAJump
    },
    data() {
      return {
        loading: false,
        filterData: {
          name: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "姓名"
          },
          highestEducation: {
            formType: "a-select",
            value: undefined,
            code: 101,
            placeholder: "最高学历",
            col: 4
          },
          status: {
            formType: "a-select",
            value: undefined,
            code: 100,
            placeholder: "员工状态",
            col: 4,
            format: function (data) {
              let res = data.filter(item => {
                return (
                  item.code != 100001 &&
                  item.code != 100002 &&
                  item.code != 100007
                );
              });
              return res;
            }
          },
          companyId: {
            formType: "a-select",
            value: undefined,
            col: 4,
            placeholder: "应聘公司",
            options: [],
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            }
          },
          recruitmentPost: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "应聘岗位"
          },
          recruitmentChannel: {
            formType: "a-select",
            code: 149,
            value: undefined,
            placeholder: "招聘渠道",
            col: 4,
            options: []
          },
          belonger: {
            formType: "a-select",
            value: undefined,
            placeholder: "归属人",
            col: 4,
            options: [],
            api: "getBelonger",
            props: {
              label: "value",
              value: "id"
            }
          },
          createTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "录入开始日期",
            endPlaceholder: "录入结束日期",
            col: 6
          },
        },
        columns: [{
            title: "姓名",
            key: "name",
            component: {
              name: OAJump,
              props: {
                textKey: "name",
                url: "talentsDetail",
                paramKey: "talentsId"
              }
            }
          },
          {
            title: "性别",
            key: "sexName",
            minWidth: 50
          },
          {
            title: "应聘公司",
            key: "companyName",
            minWidth: 200,
            showOverflowTooltip: true
          },
          {
            title: "应聘岗位",
            key: "recruitmentPost"
          },
          {
            title: "招聘渠道",
            key: "recruitmentChannelName",
            minWidth: 120,
            showOverflowTooltip: true
          },
          {
            title: "最高学历",
            key: "highestEducationName"
          },
          {
            title: "出生日期",
            key: "birthDate",
            minWidth: 100
          },
          {
            title: "录入时间",
            key: "createTime",
            minWidth: 150
          },
          {
            title: "状态",
            key: "statusName"
          },
          {
            title: "归属人",
            key: "belongerName"
          }
        ],
        data: [],
        checkList: []
      };
    },
    mounted() {},
    methods: {
      async handleSearch(val) {
        this.loading = true;
        let res = await talentsApi.getTalents(val);
        this.data = res.data.data;
        this.loading = false;
      },
      selectionChange(selection) {
        this.checkList = selection;
      },
      handleAdd(val) {
        if (this.checkList.length > 1) {
          this.$message.warning("不支持批量操作");
        } else {
          if (val == 1) {
            this.evaluate(); //评价
          } else if (val == 2) {
            this.entry(); //入职
          } else {
            //添加
            jump({
              url: "talentsDetail"
            });
          }
        }
      },
      evaluate() {
        jump({
          url: "talentsDetail",
          query: {
            talentsId: this.checkList[0].id,
            type: "c"
          }
        });
      },
      async entry() {
        let res = await talentsApi.isRequired({
          id: this.checkList[0].id
        });
        if (res.data.data) {
          jump({
            url: "staffDetail",
            query: {
              talentsId: this.checkList[0].id
            }
          });
        } else {
          this.$message.warning("员工信息未补齐，无法入职");
        }
      }
    }
  };

</script>
<style lang="scss">
  .talentsStore {
    .el-table__header {
      .headerClass {
        background-color: #edf3ff;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/personnel/talentsStore.vue